import { render, staticRenderFns } from "./IconTransmission.vue?vue&type=template&id=50c2400e"
import script from "./IconTransmission.vue?vue&type=script&lang=js"
export * from "./IconTransmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports